module.exports = __webpack_public_path__ + "img/equipment.f5cda8a8.svg";